export default __webpack_public_path__ + "static/media/Deluge of Brachial Quietuses.41bee57b.png";